import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat"
// Handles chat form interactions: submit on enter, auto-resize, clear input, and initial scroll
export default class extends Controller {
    static targets = ["input"]

    connect() {
        // Force scroll to bottom on load (for standard layouts), but with flex-col-reverse
        // we essentially want to ensure the viewport is anchored correctly.
        // Actually, with flex-col-reverse, scrollTop:0 is the TOP (which is History).
        // scrollTop: scrollHeight is the BOTTOM (Newest).
        // So we MUST scroll to bottom on connect.
        this.scrollToBottom()

        // Focus the input on connect (desktop only to avoid keyboard pop on mobile load)
        if (this.hasInputTarget && window.innerWidth > 1024) {
            this.inputTarget.focus()
        }
    }

    scrollToBottom() {
        const container = document.getElementById("messages-container")
        if (container) {
            // For flex-col-reverse, visual bottom is actually 0 if overflow-anchor is working,
            // BUT standard scroll model says 0 is top.
            // Let's force it to 0 just in case... NO wait.
            // If flex-col-reverse:
            // Top: End of DOM (History)
            // Bottom: Start of DOM (Newest)
            // ScrollTop: 0 is TOP.
            // So we need to scroll to scrollHeight?

            // Let's try scrollTop = scrollHeight. This puts us at the bottom.
            // Which is where the newest messages (start of DOM) are displayed?
            // Actually flex-col-reverse reverses the visual flow.
            // Container height > content height => content at bottom.
            // Container height < content height => overflow.
            // Scroll bar at top = End of DOM (History). Visual Top.
            // Scroll bar at bottom = Start of DOM (Newest). Visual Bottom.

            // So we want to scroll to the bottom.
            container.scrollTop = container.scrollHeight
        }
    }

    // Submit form on Enter (without Shift)
    submitOnEnter(event) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()

            const input = this.inputTarget
            if (input.value.trim() === '') return

            // Submit the form
            this.element.requestSubmit()
        }
    }

    // Auto-resize textarea as user types
    autoResize(event) {
        const textarea = event.target || this.inputTarget
        textarea.style.height = 'auto'
        textarea.style.height = (textarea.scrollHeight) + 'px'

        // Limit maximum height
        const maxHeight = 150
        if (textarea.scrollHeight > maxHeight) {
            textarea.style.height = maxHeight + 'px'
            textarea.style.overflowY = 'auto'
        } else {
            textarea.style.overflowY = 'hidden'
        }
    }

    // Clear input after successful submit
    clearInput(event) {
        if (this.hasInputTarget) {
            this.inputTarget.value = ''
            this.inputTarget.style.height = 'auto'
            this.inputTarget.focus()
            this.scrollToBottom()
        }
    }

    // TODO(Phase 06+): wire to /admin/ai/suggest_reply endpoint.
    // For now this is a UI placeholder that drops a sample suggestion
    // into the textarea so the chip is visibly interactive.
    suggestReply(event) {
        event.preventDefault()
        if (!this.hasInputTarget) return
        const placeholder = "Bonjour, merci pour votre message. Je reviens vers vous très vite avec une réponse détaillée."
        const ta = this.inputTarget
        ta.value = ta.value ? ta.value + "\n" + placeholder : placeholder
        ta.focus()
        // Trigger autoResize manually
        ta.dispatchEvent(new Event('input', { bubbles: true }))
    }
}
